// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"48113d5c","479":"fd8df581"}[chunkId] + ".chunk.js";
};